import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { useDispatch, useSelector } from 'react-redux'
import { RootState, SliceDispatch } from '.'

export interface UserState {
  token: string | null
  roleType: string
  userInfo: any
  browser: { type: string; version: string }
  choiceOrg: []
  privatize: boolean
}
let initialState: UserState
let userSlice
try {
  initialState = {
    token: localStorage.getItem('token') || localStorage.getItem('subToken'),
    roleType:
      (localStorage.getItem('token') && '主账号') ||
      (localStorage.getItem('info')
        ? window.atob(localStorage.getItem('info')) !== 'undefined' &&
          JSON.parse(unescape(window.atob(localStorage.getItem('info'))))?.user_data?.role
            ?.role_header.alias
        : ''),
    userInfo: localStorage.getItem('info')
      ? window.atob(localStorage.getItem('info')) !== 'undefined' &&
        JSON.parse(unescape(window.atob(localStorage.getItem('info'))))
      : null,
    browser: { type: '', version: '' },
    choiceOrg: [],
    privatize: false,
  }

  userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
      addToken: (store, action: PayloadAction<string>) => {
        const payloadObj = JSON.parse(action.payload) || {}
        localStorage.setItem(
          payloadObj.loginType === 'sub-account' ? 'subToken' : 'token',
          action.payload,
        )
        localStorage.setItem('loginCount', '1')
        return {
          ...store,
          token: action.payload,
        }
      },
      Super: (store, action) => ({
        ...store,
        super: action.payload,
      }),
      getBrowser: (store, action) => ({
        ...store,
        browser: action.payload,
      }),
      updateRole: (store, action) => ({
        ...store,
        roleType: action.payload,
      }),
      setUserInfo: (store, action) => ({
        ...store,
        userInfo: action.payload,
      }),
      removeToken: store => {
        localStorage.removeItem('token')
        localStorage.removeItem('subToken')
        localStorage.removeItem('loginType')
        localStorage.removeItem('loginCount')
        localStorage.removeItem('info')
        localStorage.removeItem('account_type')
        localStorage.removeItem('roleType')
        localStorage.removeItem('choiceOrg')
        return {
          ...store,
          token: null,
        }
      },
      //选择的公司数据
      setChoiceOrg: (store, action) => ({
        ...store,
        choiceOrg: action.payload,
      }),
      //获取公司数据
      getOrg: (store, action) => ({
        ...store,
        browser: action.payload,
      }),
      removeOrg: (store, action) => ({
        ...store,
        choiceOrg: [],
      }),
      //是否是私有化
      setPrivatize: (store, action) => ({
        ...store,
        privatize: action.payload,
      }),
    },
  })
} catch (error) {}
export const {
  addToken,
  removeToken,
  Super,
  updateRole,
  setUserInfo,
  setChoiceOrg,
  removeOrg,
  setPrivatize,
} = userSlice.actions
export const useUserSelector = () => useSelector((state: RootState) => state.user)
export const useUserDispatch = () => useDispatch<SliceDispatch>()
export default userSlice.reducer
